// extracted by mini-css-extract-plugin
export default {"container":"CardSection_container__8vGTu","inner":"CardSection_inner__Ib+WV","title":"CardSection_title__zNIo8","content":"CardSection_content__IIyi4"};